"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultUOMDisplay = exports.UOMDisplay = exports.UOMValue = void 0; // Note: When adding a new UOMValue, add a corresponding UOMDisplay or vice versa.
// Add new type and Update data.ts after adding new value/display

var UOMValue;

(function (UOMValue) {
  UOMValue["LB"] = "LB";
  UOMValue["PC"] = "PC";
  UOMValue["FT"] = "FT";
  UOMValue["IN"] = "IN";
  UOMValue["FT2"] = "FT2";
  UOMValue["SQIN"] = "SQIN";
  UOMValue["CWT"] = "CWT";
})(UOMValue || (exports.UOMValue = UOMValue = {})); // NOte the additions of plural "pcs" and "lb"s for quantity and weight display
// used in options for drop downs up top (i.e.  UOM_OPTIONS_PRICING,UOM_OPTIONS_QUANTITY)


var UOMDisplay;

(function (UOMDisplay) {
  UOMDisplay["CWT"] = "cwt";
  UOMDisplay["FT"] = "ft";
  UOMDisplay["FT2"] = "sqft";
  UOMDisplay["IN"] = "in";
  UOMDisplay["LB"] = "lb";
  UOMDisplay["LBS"] = "lbs";
  UOMDisplay["PC"] = "pc";
  UOMDisplay["PCS"] = "pc(s)";
  UOMDisplay["SQIN"] = "sqin";
})(UOMDisplay || (exports.UOMDisplay = UOMDisplay = {}));

var DefaultUOMDisplay;

(function (DefaultUOMDisplay) {
  DefaultUOMDisplay["CWT"] = "cwt";
  DefaultUOMDisplay["EA"] = "pc";
  DefaultUOMDisplay["FT"] = "ft";
  DefaultUOMDisplay["FT2"] = "sqft";
  DefaultUOMDisplay["IN"] = "in";
  DefaultUOMDisplay["LB"] = "lbs";
  DefaultUOMDisplay["PC"] = "pc(s)";
  DefaultUOMDisplay["SQIN"] = "sqin";
})(DefaultUOMDisplay || (exports.DefaultUOMDisplay = DefaultUOMDisplay = {}));